import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { ChevronLeft } from "lucide-react";

const COMPANY = "MoYo Stars Date Ltd, London, UK";

function Shell({ title, children, testid }) {
  return (
    <div className="min-h-screen bg-[#070d09]" data-testid={testid}>
      <header className="sticky top-0 z-40 glass border-b border-amber-500/10">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Logo size="text-2xl" to="/" />
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-slate-400 hover:text-slate-200">
            <ChevronLeft className="h-4 w-4" /> Home
          </Link>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-5 py-10">
        <h1 className="font-display font-black text-4xl gold-text">{title}</h1>
        <p className="text-xs text-emerald-100/50 mt-2">Operated by {COMPANY}</p>
        <div className="mt-8 space-y-6 text-sm text-emerald-100/80 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

export function Terms() {
  return (
    <Shell title="Terms of Service" testid="terms-page">
      <p>Welcome to MoYo Stars Date. By creating an account you agree to use the service respectfully and lawfully. MoYo Stars Date connects people who want to attend the same real-world events and meet on a short video "vibe check" before chatting.</p>
      <div><h2 className="text-white font-semibold text-base">Your account</h2><p className="mt-2">You are responsible for the activity on your account and for the accuracy of the information you provide. You must be of legal age in your jurisdiction to use a dating service.</p></div>
      <div><h2 className="text-white font-semibold text-base">Acceptable use</h2><p className="mt-2">No harassment, impersonation, or unlawful content. We may suspend accounts that violate these terms or the safety of other members.</p></div>
      <div><h2 className="text-white font-semibold text-base">Matching & events</h2><p className="mt-2">Matching is organised around local event pools. Certain designated test events may allow wider matching for development purposes.</p></div>
      <div><h2 className="text-white font-semibold text-base">Changes</h2><p className="mt-2">We may update these terms. Continued use after changes constitutes acceptance. {COMPANY} is the data controller for this service.</p></div>
    </Shell>
  );
}

export function Privacy() {
  return (
    <Shell title="Privacy Policy" testid="privacy-page">
      <p>Your privacy matters. This policy explains what {COMPANY} collects and how it is used. We never sell your personal data, and your billing details are kept private to your account.</p>
      <div><h2 className="text-white font-semibold text-base">What we collect</h2><p className="mt-2">Profile details you provide (name, age, city, photos, bio), the events you express interest in, and basic usage data needed to run matching, chat and video vibe checks.</p></div>
      <div><h2 className="text-white font-semibold text-base">How we use it</h2><p className="mt-2">To create matches within your local pool, enable video vibe checks and chat, and send you relevant notifications. Video calls are powered by a third-party real-time provider and are not recorded by us.</p></div>
      <div><h2 className="text-white font-semibold text-base">Your choices</h2><p className="mt-2">You can edit your profile, manage notification preferences, and request deletion of your account at any time.</p></div>
      <div><h2 className="text-white font-semibold text-base">Contact</h2><p className="mt-2">For privacy requests, contact the data controller: {COMPANY}.</p></div>
    </Shell>
  );
}
